import axios from "axios";
import { api } from "../api_route";

export const getSflCaseDetails = async (values) => {
    try {
        const result = await axios.post(`${api}/sflCaseDetails/`, { values });
        return result.data;
    } catch (error) {
        return { data: {} };
    }
};

export const updateSflCaseDetails = async (values) => {
    try {
        const result = await axios.post(`${api}/sflCaseDetails/update`, values);
        return result.data;
    } catch (error) {
        throw error;
    }
};
